import { DzkpBody } from '@/interface/api/home/invoicing'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const invoicingPinia = defineStore('invoicingPinia', () => {
  const firms = ref<string[]>([])
  function setCurFirm(arr: string[]) {
    firms.value = arr
  }
  const orderDetail = ref<DzkpBody[]>([])
  const setOrderDetail = (info: DzkpBody[] = []) => {
    orderDetail.value = info
  }
  const redInvoiceType = ref<string | null>(null)
  const setRedInvoiceType = (str: string | null = null) => {
    redInvoiceType.value = str
  }
  const downloadFileName = ref<string>('')
  const setDownloadFileName = (str: string) => {
    downloadFileName.value = str
    console.log(downloadFileName.value)
  }
  return {
    firms,
    setCurFirm,
    orderDetail,
    setOrderDetail,
    redInvoiceType,
    setRedInvoiceType,
    downloadFileName,
    setDownloadFileName
  }
})
export default invoicingPinia
